import React, { ChangeEvent, ReactNode } from "react";
import iconChecked from "../../assets/svg/icon-checked.svg";
import iconNotChecked from "../../assets/svg/icon-not-checked-black.svg";
import styled from "styled-components";

interface ICheckbox {
  label: string;
  text: string | ReactNode;
  checked: boolean;
  setChecked: any;
}

export default function Checkbox({
  label,
  text,
  checked,
  setChecked,
}: ICheckbox) {
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
  };

  return (
    <CheckboxStyled>
      <label htmlFor={label}>
        <input
          id={label}
          type="checkbox"
          checked={checked}
          onChange={onChangeHandler}
        />
        <img src={checked ? iconChecked : iconNotChecked} alt="" />
        <div>{text}</div>
      </label>
    </CheckboxStyled>
  );
}

const CheckboxStyled = styled.fieldset`
  label {
    display: flex;
    align-items: center;
    column-gap: 1.6rem;
  }

  input {
    display: none;
  }

  div {
    font-size: 1.4rem;
    color: var(--color-grey-900);

    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
